export default __webpack_public_path__ + "static/cloudator-responsive-accordion-component-49d2e7da8648c175657bd4efee175a3d.jpg";